import { render, staticRenderFns } from "./EventDetailDialog.vue?vue&type=template&id=ccf3d7e8&scoped=true&"
import script from "./EventDetailDialog.vue?vue&type=script&lang=js&"
export * from "./EventDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./EventDetailDialog.vue?vue&type=style&index=0&id=ccf3d7e8&prod&lang=css&"
import style1 from "./EventDetailDialog.vue?vue&type=style&index=1&id=ccf3d7e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf3d7e8",
  null
  
)

export default component.exports